import SharedResource from '@/mixins/shared-resource'
import Draggable from 'vuedraggable'

export default {
  mixins: [SharedResource],
  components: {
    'v-draggable': Draggable,
  },
  data() {
    return {
      valid: false,
      tab: null,
      loading: {
        fetching: false,
        creating: false,
        cancelling: false,
        creatingAlt: false,
      },
      rules: {},
      formData: {},
    }
  },
  computed: {
    disabled() {
      return Object.keys(this.loading).some(loading => this.loading[loading] === true)
    },
  },
  methods: {
    async cancelCreatingResource() {
      this.loading.cancelling = true
      this.$router.push(this.redirectToIndexView())
    },
    async createResourceWithoutRedirect() {
      this.loading.creatingAlt = true
      if (!this.$refs.form.validate()) return (this.loading.creatingAlt = false)
      await this.createResource()
        .then(() => {
          this.loading.creatingAlt = false
          this.$refs.form.reset()
          this.$refs.form.resetValidation()
        })
        .catch(() => {
          this.loading.creatingAlt = false
        })
    },
    async createResourceWithRedirect() {
      this.loading.creating = true
      if (!this.$refs.form.validate()) return (this.loading.creating = false)
      await this.createResource()
        .then(() => {
          this.loading.creating = false
          this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.$router.push(this.redirectToView(this.resource.id))
        })
        .catch(() => {
          this.loading.creating = false
        })
    },
  },
}
